import { FC } from 'react';
import { InputText } from '@lambdacurry/component-library';
import { InputGrid } from '../InputGrid';

export interface ConfirmPasswordInputGroupProps {
  name?: string;
  label?: string;
}

export const ConfirmPasswordInputGroup: FC<ConfirmPasswordInputGroupProps> = ({ name, label = 'Password' }) => {
  const fieldPrefix = name ? `${name}.` : '';

  return (
    <InputGrid>
      <InputText name={`${fieldPrefix}new_password`} label={label} type="password" />
      <InputText name={`${fieldPrefix}confirm_password`} label={`Confirm ${label}`} type="password" />
    </InputGrid>
  );
};
